import { deleteApi, get, post } from "../GenericServices";

const CarFuelRefund = {
  getCarFuelRefunds: (queryString) => {
    return get(`car-fuel-refund${queryString !== "" ? `?${queryString}` : ""}`);
  },
  getCarFuelRefund: (id) => {
    return get(`car-fuel-refund/${id}`);
  },
  setCarFuelRefund: (data) => {
    return post(`car-fuel-refund`, data);
  },
  deleteCarFuelRefund: (id) => {
    return deleteApi(`car-fuel-refund/${id}`);
  },
};

export default CarFuelRefund;
